export default __webpack_public_path__ + "static/media/3、首页多多柠檬茶.40f76bef.jpg";